import * as angular from 'angular';
import './styling.scss';
import * as markerImageUrl from './location-marker.svg';

const module = angular.module('location-map', []);

interface LocationMapController extends angular.IStrictController {
    address: string;
    clickable?: boolean;
}

if (!(HTMLElement as any).appliedIEFix) {
    (HTMLElement as any).appliedIEFix = true;

    (HTMLElement.prototype as any)._getBoundingClientRect = HTMLElement.prototype.getBoundingClientRect;
    HTMLElement.prototype.getBoundingClientRect = function() {
        try {
            return (this as any)._getBoundingClientRect();
        } catch (e) {
            return { top: this.offsetTop, left: this.offsetLeft };
        }
    };
}

module.component('locationMap', {
    bindings: {
        address: '<',
        clickable: '<?'
    },
    controller: function(this: LocationMapController, $element: angular.IAugmentedJQuery) {
        const $ctrl = this;

        this.$onInit = () => {
            new google.maps.Geocoder().geocode(
                {
                    address: this.address
                },
                (results: Array<google.maps.GeocoderResult>, status: google.maps.GeocoderStatus) => {
                    try {
                        const location = results[0].geometry.location;
                        initializeMap(location.lat(), location.lng());
                    } catch (e) {
                        // TODO: throttle geocode requests to avoid rate limit
                    }
                }
            );
        };

        function initializeMap(latitude: number, longitude: number) {
            const map = new google.maps.Map($element[0], {
                zoom: 16,
                center: {
                    lat: latitude,
                    lng: longitude
                },
                clickableIcons: false,
                disableDefaultUI: true,
                draggable: false,
                draggableCursor: $ctrl.clickable ? 'pointer' : 'default',
                draggingCursor: $ctrl.clickable ? 'pointer' : 'default',
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        featureType: 'poi',
                        stylers: [
                            {
                                visibility: 'off'
                            }
                        ]
                    },
                    {
                        featureType: 'transit',
                        stylers: [
                            {
                                visibility: 'off'
                            }
                        ]
                    },
                    {
                        featureType: 'administrative',
                        stylers: [
                            {
                                visibility: 'off'
                            }
                        ]
                    }
                ]
            });

            // because we call new, we either get an unused variable error or an unused expression error
            // tslint:disable-next-line
            const locationMarker = new google.maps.Marker({
                clickable: !!$ctrl.clickable,
                position: {
                    lat: latitude,
                    lng: longitude
                },
                map: map,
                icon: markerImageUrl
            });
        }
    }
});

export { module };
